import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '福利导航是免费使用的吗？',
    answer: '是的，福利导航完全免费使用。我们致力于为所有用户提供优质的福利资源聚合服务，不收取任何费用。我们通过整理和推荐优质的福利信息，帮助用户省时省钱地找到最适合自己的福利和优惠。',
  },
  {
    question: '福利信息多久更新一次？',
    answer: '我们的团队每天都会监控各大平台的福利动态，确保信息的及时性和准确性。重点关注电商大促（双十一、618等）、会员日活动、节假日福利等时间节点，确保您不会错过任何重要福利。对于限时活动，我们会在活动开始前提前发布预告。',
  },
  {
    question: '如何确保福利信息的真实性？',
    answer: '我们建立了一套严格的福利信息审核机制：所有发布的福利信息都经过人工核实，优先收录官方渠道发布的福利。对于用户投稿的福利信息，我们会进行多方交叉验证后再发布。同时我们也会标注福利的时效性，方便用户判断。',
  },
  {
    question: '我发现了好的福利，可以投稿吗？',
    answer: '当然可以！我们非常欢迎用户分享发现的优质福利。您可以通过网站底部的联系方式或官方公众号向我们投稿。一经采纳，我们会在文章中注明贡献者，让更多人受益于您的发现。',
  },
  {
    question: '福利导航包含哪些类型的福利？',
    answer: '目前福利导航覆盖六大福利类目：电商优惠（淘宝、京东等平台优惠券）、会员权益（视频、音乐等平台会员福利）、生活补贴（租房、交通等补贴政策）、职场福利（求职补贴、技能培训等）、免费福利（试用、样品、课程等免费资源）、金融福利（信用卡权益、理财红包等）。我们持续拓展新的福利类目，让福利覆盖生活的方方面面。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于福利导航，你关心的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}